"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrubDataId = void 0;
const scrubDataId = (dataId) => {
    return dataId
        .toLowerCase()
        .replaceAll(' ', '-') // remove blank spaces
        .replaceAll(/--+/g, '-'); // remove multiple dashes
};
exports.scrubDataId = scrubDataId;
//# sourceMappingURL=scrub_data_id.js.map